import {
    ImgHTMLAttributes, RefObject, useEffect, useState,
} from 'react';

import placeholder from './img_placeholder.png';

interface Props extends ImgHTMLAttributes<HTMLImageElement>{
  border?: boolean;
  ref?: RefObject<HTMLImageElement|null>;
}

function Image(props: Props) {
    const {
        src: propSrc, alt, border, ref, ...rest
    } = props;
    const [src, setSrc] = useState<string>('');
    useEffect(() => {
        if (propSrc) {
            const img = new window.Image();
            const newSrc = propSrc;
            img.src = propSrc;

            img.onload = () => setSrc(newSrc);
        }
    }, [propSrc]);
    return (<img src={src || placeholder}
        ref={ref}
        alt={alt}
        {...rest}/>);
}

export default Image;
